import React, { useEffect, useState } from "react";
import "./../../assets/styles/Style.css";
import { NavMenu } from "./NavMenu";
import { useNavigate } from "react-router-dom";
import { useLocation} from "react-router-dom"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faKey, faMobile, faMobileAlt, faRefresh, faUserAlt, faEyeSlash, faEye } from "../../../node_modules/@fortawesome/free-solid-svg-icons/index";
import '../../assets/styles/Login.css';
import{Tabs, Tab} from 'react-bootstrap';
import splash from '../../assets/images/Splash.jpg'
import "bootstrap-icons/font/bootstrap-icons.css";
import KrishiMapperlogo from '../../assets/images/krishiMapper.png';
import agricultureDarkLogo from '../../assets/images/agriculture-logo-dark.png';
import { Link } from "react-router-dom";
import blockedData from "../../config/blockedSchemes.json";
import { persistLoginAuth } from "../../setupAxios";

// Export constant loaded from JSON
export const BLOCKED_SCHEMES = blockedData.BLOCKED_SCHEMES;
let loginDetails = {};






function Login(props) {

    //const [BLOCKED_SCHEMES, setBlockedSchemes] = useState([]);
    //useEffect(() => {
    //    // file path relative to public/
    //    fetch(`${process.env.PUBLIC_URL}/blockedSchemes.json`)
    //        .then((res) => res.json())
    //        .then((data) => {
    //            // expect { BLOCKED_SCHEMES: [...] }
    //            if (data && Array.isArray(data.BLOCKED_SCHEMES)) {
    //                setBlockedSchemes(data.BLOCKED_SCHEMES);
    //            }
    //        })
    //        .catch((err) => {
    //            console.error("Failed to load blockedSchemes.json", err);
    //            setBlockedSchemes([]); // fallback
    //        });
    //}, []);
    //const schemeGlobal = sessionStorage.getItem("schemeCodeModel");
    //const schemeGlobal = schemeValue;

    // Use global variable
    /*const isSchemeBlocked = BLOCKED_SCHEMES.includes(schemeGlobal);*/

  let location = useLocation();
  location.state ? console.log("true") : console.log("false");

  const [captchaTexts, setCaptchaTexts] = useState(''); 
  const [captchaTexts2, setCaptchaTexts2] = useState(''); 
  const [userInput, setUserInput] = useState(''); 
  const [userInput2, setUserInput2] = useState(''); 
  const [schemeValue, setSchemeValue] = useState('');
  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [type, setType] = useState('password');
  const [isLoading, setIsLoading] = useState(false); 
const [icon, setIcon] = useState(faEyeSlash);
const [passwordShown, setPasswordShown] = useState(false);

 // console.log("propsss",location.state);
    const navigate = useNavigate();
    let captchaText;
    let userText;
    var code;
    let output = document.querySelector("#output");
    let refreshButton;
    let alphaNums = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', '0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];

    let captchaText2;
    let userText2;
    var code2;
    let output2 = document.querySelector("#output2");
    let refreshButton2;
    let  alphaNums2 = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', '0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
;

    let loginCount = 0;
   
    

    useEffect(() => {
      localStorage.removeItem("username");
        //  captchaText = document.querySelector('#captcha');    
         userText = document.querySelector('#textBox');
        let submitButton = document.querySelector('#login_btn');
        output = document.querySelector('#output');
        refreshButton = document.querySelector('#refresh');
        let emptyArr = [];
        for (let i = 1; i <= 6; i++) {
            emptyArr.push(alphaNums[Math.floor(Math.random() * alphaNums.length)]);
        }
         captchaText = emptyArr.join('');
         //console.log("captchaText 2", captchaText);
         setCaptchaTexts(captchaText)
        // Draw canvas   
        var canv = document.createElement("canvas");
        canv.id = "captcha";
        canv.width = 100;
        canv.height = 35;
        var ctx = canv.getContext("2d");
        ctx.font = "20px arial";
         ctx.top = "20px";
        ctx.color ="#008957"
        ctx.strokeText(emptyArr.join(""), 0, 30);
        //storing captcha so that can validate you can save it somewhere else according to your specific requirements
        code = emptyArr.join("");
        document.getElementById("captcha").replaceWith(canv);          
    }, [])

    useEffect(() => {
      //  captchaText = document.querySelector('#captcha');    
       userText2 = document.querySelector('#textBox2');
      let submitButton2 = document.querySelector('#login_btn2');
      output2 = document.querySelector('#output2');
      refreshButton2 = document.querySelector('#refresh2');
      
      let emptyArr2 = [];
      for (let i = 1; i <= 6; i++) {
          emptyArr2.push(alphaNums2[Math.floor(Math.random() * alphaNums2.length)]);
      }
       captchaText2 = emptyArr2.join('');
       setCaptchaTexts2(captchaText2)
      // Draw canvas   
      var canv2 = document.createElement("canvas");
      canv2.id = "captcha2";
      canv2.width = 100;
      canv2.height = 35;
      var ctx2 = canv2.getContext("2d");
      ctx2.font = "20px arial";
       ctx2.top = "20px";
      ctx2.color ="#008957"
      ctx2.strokeText(emptyArr2.join(""), 0, 30);
      //storing captcha so that can validate you can save it somewhere else according to your specific requirements
      code2 = emptyArr2.join("");
      document.getElementById("captcha2").replaceWith(canv2);          
  }, [])

    function RefreshButton() {
           
            setUserInput("")
            let refreshArr = [];
            for (let j = 1; j <= 6; j++) {
                refreshArr.push(alphaNums[Math.floor(Math.random() * alphaNums.length)]);
            }
             captchaText = refreshArr.join('');
             //console.log("captchaText 3", captchaText);
             setCaptchaTexts(captchaText)
             output.innerHTML = "";
            var canv = document.createElement("canvas");
            canv.id = "captcha";
            canv.width = 100;
            canv.height = 35;
            var ctx = canv.getContext("2d");
            ctx.font = "20px arial";
             ctx.top = "20px";
            ctx.color ="#008957"      
            ctx.strokeText(refreshArr.join(""), 0, 30);
            //storing captcha so that can validate you can save it somewhere else according to your specific requirements
            code = refreshArr.join("");      
            document.getElementById("captcha").replaceWith(canv);  
    }

    function RefreshButton2() {
     
      setUserInput2("")
      let refreshArr2 = [];
      for (let j = 1; j <= 6; j++) {
          refreshArr2.push(alphaNums2[Math.floor(Math.random() * alphaNums2.length)]);
      }
       captchaText2 = refreshArr2.join('');
       setCaptchaTexts2(captchaText2)
       output2.innerHTML = "";
      var canv2 = document.createElement("canvas");
      canv2.id = "captcha2";
      canv2.width = 100;
      canv2.height = 35;
      var ctx2 = canv2.getContext("2d");
      ctx2.font = "20px arial";
       ctx2.top = "20px";
      ctx2.color ="#008957"      
      ctx2.strokeText(refreshArr2.join(""), 0, 30);
      //storing captcha so that can validate you can save it somewhere else according to your specific requirements
      code2 = refreshArr2.join("");      
      document.getElementById("captcha2").replaceWith(canv2);  
}


  
    function LoginCropic() {

        //console.log('hhhhhhh');
        sessionStorage.setItem("finYear", "2025-2026");
        // localStorage.setItem("username", String(document.getElementById("yourUsername").value))
        localStorage.setItem("usertype", "admin")
        let outputCred = document.querySelector('#outputCred');
        let output = document.querySelector('#output');

    
        const asyncPostCall = async () => {
            try {
             
             
              localStorage.setItem(userName , loginCount)
                const response = await fetch(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/otpauth/PasswordAuth`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        "userId": userName,
                        "password": password,
                        "schemeCode": "16"
                    })
                });
                const data = await response.json();
                console.log("Login response:", data);
                
                if (data.success && data.dataContent && data.dataContent.length > 0) {
                    outputCred.innerHTML = '';
                    const userData = data.dataContent[0];
                    
                    // Store all session data
                    sessionStorage.setItem("userCodeModel", userData.userCode);
                    sessionStorage.setItem("userNameModel", userData.userName);
                    sessionStorage.setItem("userRoleCode", userData.userRoleCode);
                    sessionStorage.setItem("schemeCodeModel", userData.schemeCode);
                    sessionStorage.setItem("userTypeCodeModel", userData.userTypeCode);
                    sessionStorage.setItem("stateCodeModel", userData.userRoleName);
                    sessionStorage.setItem("atariCode", userData.atariCode);
                    sessionStorage.setItem("kvkCode", userData.kvkCode);
                    
                    
                    // Store FMTTI and FMTC data - ensure both code and name are stored
                    if (userData.fmttiCode !== null && userData.fmttiCode !== undefined) {
                        console.log("Setting FMTTI code:", userData.fmttiCode);
                        sessionStorage.setItem("fmttiCode", userData.fmttiCode.toString());
                    }
                    if (userData.fmttiName) {
                        console.log("Setting FMTTI name:", userData.fmttiName);
                        sessionStorage.setItem("fmttiName", userData.fmttiName);
                    }
                    if (userData.fmtcCode !== null && userData.fmtcCode !== undefined) {
                        console.log("Setting FMTC code:", userData.fmtcCode);
                        sessionStorage.setItem("fmtcCode", userData.fmtcCode.toString());
                    }
                    if (userData.fmtcName) {
                        console.log("Setting FMTC name:", userData.fmtcName);
                        sessionStorage.setItem("fmtcName", userData.fmtcName);
                    }
                    
                    // Store complete login data for reference
                    const loginDataToStore = {
                        ...userData,
                        fmttiCode: userData.fmttiCode?.toString(),
                        fmtcCode: userData.fmtcCode?.toString(),
                        fmttiName: userData.fmttiName,
                        fmtcName: userData.fmtcName
                    };
                    console.log("Storing login data:", loginDataToStore);
                    sessionStorage.setItem("loginData", JSON.stringify(loginDataToStore));
                    
                    // Set user session for ProtectedRoute
                    sessionStorage.setItem("user", true);
                    
                    // Navigate to dashboard
                    navigate("/MNT/dashboardMnT");
                } else {
                  
                   localStorage.setItem(userName, ++loginCount)
                    outputCred.innerHTML = "Invalid Credential, please try again";
                    RefreshButton()
                     setIsLoading(false);
                }
                console.log("captchaText 4" ,captchaText);

                if (captchaTexts === userInput) {
                    output.innerHTML = '';
                } else {
                    RefreshButton()
                    output.innerHTML = "Incorrect Captcha, please try again";
                     setIsLoading(false);
                   
                }

                // if(loginCount > 3) {
                //   alert("User blocked for 30 min")

                // }

                if(data.success === false) {
                  alert(data.message)
                   setIsLoading(false);
                }
                
                if (data.success && captchaTexts === userInput && data.dataContent[0].isActive === "Yes") {
                  localStorage.setItem("userCodeGlobal", data.dataContent[0].userCode)
                  localStorage.setItem("username", data.dataContent[0].userName)
                  // localStorage.setItem("usertype", "admin")
                    APICallforuserRoleCode(data.dataContent[0].userCode)
                     setIsLoading(false);
                   
                }
              
            } catch (error) {
     
                console.log(error)
            }
        }

        asyncPostCall()  
        
    }

    function LoginCropic2() {
      
     
      let outputCred2 = document.querySelector('#outputCred2');
      let output2 = document.querySelector('#output2');

  
      const asyncPostCall2 = async () => {
          try {
           
           
           
              const response = await fetch(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/otpauth/MobileAuth`, {
                  method: 'POST',
                  headers: {
                      'Content-Type': 'application/json'
                  },
                  body: JSON.stringify({
                      "mobileno": String(document.getElementById("MobileNumber").value),
                      "OTP": String(document.getElementById("inputotp").value)
                  })
              });
              const data = await response.json();
              loginDetails = data.dataContent[0]
              // localStorage.setItem("userRoleCode", loginDetails.userRoleCode)
             if (data.success) {
                  outputCred2.innerHTML = ''
                   setIsLoading(false);
              } else {
                
        
                  outputCred2.innerHTML = "Invalid Credential, please try again";
                  RefreshButton2()
                   setIsLoading(false);
              }

              if (captchaTexts2 === userInput2) {
                  output2.innerHTML = '';
              } else {
                  RefreshButton2()
                  output2.innerHTML = "Incorrect Captcha, please try again";
                   setIsLoading(false);
                 
              }

              // if(loginCount > 3) {
              //   alert("User blocked for 30 min")

              // }

               if(data.dataContent[0].isActive === "No") {
                  alert("User is not active")
                   setIsLoading(false);
                }
                
              
              if (data.success && captchaTexts2 === userInput2 && data.dataContent[0].isActive === "Yes") {
                localStorage.setItem("userCodeGlobal", data.dataContent[0].userCode)
                localStorage.setItem("username", data.dataContent[0].userName)
                localStorage.setItem("usertype", "admin")
                  APICallforuserRoleCode(data.dataContent[0].userCode)
                   setIsLoading(false);
                 
              }
            
          } catch (error) {
   
              console.log(error)
          }
      }

      asyncPostCall2()  
      
  }

  function LoginInspection() {
      
  
    let outputCred = document.querySelector('#outputCred');
     let output = document.querySelector('#output');

  const asyncPostCallInsp = async () => {
   
      try {

        
        if(userName === "" || password === "") {
          alert("Enter UserName and Password")
           setIsLoading(false);
          return;
        }

        if(schemeValue === "Choose...") {
          alert("Enter Any Scheme")
           setIsLoading(false);
          return;
        }
       
       
       
       
          const response = await fetch(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/inspectionUsers/useridpasswordauth`, {
              method: 'POST',
              headers: {
                  'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                  "userid": userName,
                  "Password": password
              })
          });
          const data3 = await response.json();
         // console.log("test----",data3.dataContent[0].multiDistrict)
          
          loginDetails = data3.dataContent[0]
         
         if (data3.success) {
              outputCred.innerHTML = ''
               setIsLoading(false);
          } else {
            
       
              outputCred.innerHTML = "Invalid Credential, please try again";
               setIsLoading(false);
              RefreshButton()
          }

        

          if (captchaTexts === userInput) {
              output.innerHTML = '';
          } else {
              RefreshButton()
              output.innerHTML = "Incorrect Captcha, please try again";
               setIsLoading(false);
             
          }


          
          if (data3.success && captchaTexts === userInput && data3.dataContent[0].isActive === "Yes") {
              sessionStorage.setItem("user", true)
              sessionStorage.setItem("currentSchemeName", data3.dataContent[0].schemeName)
              sessionStorage.setItem("currentStateName", data3.dataContent[0].stateName)
              sessionStorage.setItem("currentDistrictName", data3.dataContent[0].districtName)
              sessionStorage.setItem("multiDistrict", JSON.stringify(data3.dataContent[0].multiDistrict));

          
              sessionStorage.setItem("gender", data3.dataContent[0].gender)
              sessionStorage.setItem("userName", data3.dataContent[0].userName)
              sessionStorage.setItem("userId", data3.dataContent[0].userId)
              sessionStorage.setItem("userCode", data3.dataContent[0].userCode)
              location.state  ? navigate("/Map") : navigate("/inspection/dashboard")  
               setIsLoading(false);

             
          }
        
      } catch (error) {

          console.log(error)
      }
  }

  asyncPostCallInsp()  
  
}

    function LoginMIDH() {
      
       
  let outputCred = document.querySelector('#outputCred');
  let output = document.querySelector('#output');

  const asyncPostCallModel = async () => {
      try {
          setIsLoading(true);

          // Validation checks
          if (userName === "" || password === "") {
              alert("Enter Username and Password");
              setIsLoading(false);
              return;
          }

          if (schemeValue === "Choose...") {
              alert("Select a valid Scheme");
              setIsLoading(false);
              return;
          }
          
          const baseUrl = process.env.NODE_ENV === 'development'
              ? process.env.REACT_APP_DEV_MODE
              : process.env.REACT_APP_PRO_MODE;

          
          const endpoint = ["5", "48"].includes(schemeValue)
  ? "/api/NMEOSUsers/getNMEOSUsersAuth"
  : "/api/Management/CommUsers/getUsersAuth";

          const response = await fetch(`${baseUrl}${endpoint}`, {
              method: 'POST',
              headers: {
                  'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                  SchemeCode: schemeValue,
                  userId: userName,
                  password: password,
              }),
          });

         

          const data4 = await response.json();
         
          
        
          // --- Handle login failure ---
          if (!data4.success) {
              alert(data4.message || "Invalid Credentials, please try again.");
              outputCred.innerHTML = data4.message || "Invalid Credential, please try again";
              setIsLoading(false);
              RefreshButton();
              return;
          }

          // --- Handle captcha mismatch ---
          if (captchaTexts !== userInput) {
              alert("Incorrect Captcha, please try again.");
              output.innerHTML = "Incorrect Captcha, please try again";
              RefreshButton();
              setIsLoading(false);
              return;
          }



          // --- Successful login ---
          const userData = data4.dataContent[0];
          console.log('userData : ', userData);
         
          let districtArray;
          let BlockArray;
          if (userData.userTypeCode === 3) {
              // Split the strings into arrays
              const districtNames = userData.mulDistrictName ? userData.mulDistrictName.split(',') : [];
              const districtCodes = userData.mulDistrictCode ? userData.mulDistrictCode.split(',') : [];

              // Create key-value pairs
              const districtKeyValuePairs = {};

              // Map district codes to district names
              districtCodes.forEach((code, index) => {
                  if (code && code.trim() !== '') {
                      const name = districtNames[index] ? districtNames[index].trim() : `District_${code}`;
                      districtKeyValuePairs[code.trim()] = name;
                  }
              });

              // Alternative approach using reduce
              const districtKeyValuePairs2 = districtCodes.reduce((acc, code, index) => {
                  if (code && code.trim() !== '') {
                      const name = districtNames[index] ? districtNames[index].trim() : `District_${code}`;
                      acc[code.trim()] = name;
                  }
                  return acc;
              }, {});

              // If you want an array of objects instead of key-value pairs
               districtArray = districtCodes.map((code, index) => {
                  if (code && code.trim() !== '') {
                      return {
                          code: code.trim(),
                          name: districtNames[index] ? districtNames[index].trim() : `District_${code}`
                      };
                  }
                  return null;
              }).filter(item => item !== null);

              // Example usage:
              //console.log('Key-Value Pairs:', districtKeyValuePairs);
              // console.log('Array of Objects:', districtArray);
          }
          //console.log('userData.userTypeCode: ', userData.userTypeCode)
          if (userData.userTypeCode === 4) {
              //console.log('start here');
              // if (userData.schemeCode !== "2") {
              //console.log('start here if not 2');
              const districtNames = userData.mulSubDistrictName ? userData.mulSubDistrictName.split(',') : [];
              const districtCodes = userData.mulSubDistrictCode ? userData.mulSubDistrictCode.split(',') : [];

              // Create key-value pairs
              const districtKeyValuePairs = {};

              // Map district codes to district names
              districtCodes.forEach((code, index) => {
                  if (code && code.trim() !== '') {
                      const name = districtNames[index] ? districtNames[index].trim() : `District_${code}`;
                      districtKeyValuePairs[code.trim()] = name;
                  }
              });

              // Alternative approach using reduce
              const districtKeyValuePairs2 = districtCodes.reduce((acc, code, index) => {
                  if (code && code.trim() !== '') {
                      const name = districtNames[index] ? districtNames[index].trim() : `District_${code}`;
                      acc[code.trim()] = name;
                  }
                  return acc;
              }, {});

              //console.log('districtCodes: ', districtCodes);
              // If you want an array of objects instead of key-value pairs
              districtArray = districtCodes.map((code, index) => {
                  if (code && code.trim() !== '') {
                      return {
                          code: code.trim(),
                          name: districtNames[index] ? districtNames[index].trim() : `District_${code}`
                      };
                  }
                  return null;
              }).filter(item => item !== null);

              //console.log('districtArray-Sub-District: ', districtArray);
              //} else {
              //if (districtArray && districtArray.trim() !== "")
              //console.log('start here if  2 222222 before');
              //if (Array.isArray(districtArray) && districtArray.length < 0) 
              if ( Array.isArray(districtArray) && districtArray.length === 0)
              { 
                      //console.log('start here if  2 222222');
                      const BlockNames = userData.mulBlockName ? userData.mulBlockName.split(',') : [];
                      const BlockCodes = userData.mulBlockName ? userData.mulBlockCode.split(',') : [];
                  //console.log('BlockCodes: ', BlockCodes);
                  //console.log('BlockNames: ', BlockNames);
                      // Create key-value pairs
                      const BlockKeyValuePairs = {};

                      // Map district codes to district names
                      BlockCodes.forEach((code, index) => {
                          if (code && code.trim() !== '') {
                              const name = BlockNames[index] ? BlockNames[index].trim() : `Block_${code}`;
                              BlockKeyValuePairs[code.trim()] = name;
                          }
                      });

                      // Alternative approach using reduce
                      const BlockKeyValuePairs2 = BlockCodes.reduce((acc, code, index) => {
                          if (code && code.trim() !== '') {
                              const name = BlockNames[index] ? BlockNames[index].trim() : `Block_${code}`;
                              acc[code.trim()] = name;
                          }
                          return acc;
                      }, {});

                      //console.log('districtCodes: ', districtCodes);
                      // If you want an array of objects instead of key-value pairs
                      districtArray = BlockCodes.map((code, index) => {
                          if (code && code.trim() !== '') {
                              return {
                                  code: code.trim(),
                                  name: BlockNames[index] ? BlockNames[index].trim() : `Block_${code}`
                              };
                          }
                          return null;
                      }).filter(item => item !== null);
          }
              //console.log('districtArray-Block: ', districtArray);
              //}

          } //end sub district

          console.log('userData: ', userData);
          const savedLoginToken = persistLoginAuth(data4) || persistLoginAuth(userData);
          sessionStorage.clear();
          if (savedLoginToken) persistLoginAuth({ token: savedLoginToken });
          sessionStorage.setItem("currentSchemeName", userData.schemeName || "");
          sessionStorage.setItem("currentStateName", userData.stateName || "");
          sessionStorage.setItem("currentDistrictName", userData.districtName || "");
          sessionStorage.setItem("multiDistrict", JSON.stringify(userData.multiDistrict) || []);

          sessionStorage.setItem("userCodeModel", userData.userCode || "");
          sessionStorage.setItem("userTypeCodeModel", userData.userTypeCode || "");
          sessionStorage.setItem("stateNameModel", userData.stateCode || "");
         // sessionStorage.setItem("districtNameModel", userData.districtCode); changed at 1 sept 2025
          sessionStorage.setItem("districtNameModel", userData.districtName || "");
          sessionStorage.setItem("subDistrictNameModel", userData.subDistrictName || "");
          sessionStorage.setItem("villageModel", userData.villageCode || "");
          sessionStorage.setItem("villageName", userData.villageName || "");
          
          sessionStorage.setItem("schemeCodeModel", schemeValue || "");
          sessionStorage.setItem("userNameModel", userData.userName || "");
          sessionStorage.setItem("stateCodeModel", userData.stateCode );
          sessionStorage.setItem("districtCodeModel", userData.districtCode || "");
          sessionStorage.setItem("subDistrictCodeModel", userData.subDistrictCode || "");
          //sessionStorage.setItem("districtArray", districtArray);

          //Block level
          sessionStorage.setItem("blockName", userData.blockName || "");
          sessionStorage.setItem("blockCode", userData.blockCode || "");
          sessionStorage.setItem("mulBlockCode", userData.mulBlockCode || "");
          //sessionStorage.setItem("mulBlockName1", userData.mulBlockName || "");
          sessionStorage.setItem("mulBlockName", userData.mulBlockName || "");

          sessionStorage.setItem("districtArray", JSON.stringify(districtArray) || []);
          sessionStorage.setItem("user", true);
          navigate(location.state ? "/Map" : "/newadminpanel/dashboard");
          setIsLoading(false);
      } catch (error) {
          console.error("Login Error:", error);
          alert("Something went wrong during login. Please try again.");
          setIsLoading(false);
      }
  };

  asyncPostCallModel();
}
function LoginModel() {
  let outputCred = document.querySelector('#outputCred');
  let output = document.querySelector('#output');

  const asyncPostCallModel = async () => {
    try {
      setIsLoading(true);

      // Validation checks
      if (userName === "" || password === "") {
        alert("Enter Username and Password");
        setIsLoading(false);
        return;
      }

      if (schemeValue === "Choose...") {
        alert("Select a valid Scheme");
        setIsLoading(false);
        return;
      }

      const baseUrl = process.env.NODE_ENV === 'development'
        ? process.env.REACT_APP_DEV_MODE
        : process.env.REACT_APP_PRO_MODE;

      const endpoint = ["5", "48"].includes(schemeValue)
  ? "/api/NMEOSUsers/getNMEOSUsersAuth"
  : "/api/Management/CommUsers/getUsersAuth";
      const response = await fetch(`${baseUrl}${endpoint}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          SchemeCode: schemeValue,
          userId: userName,
          password: password,
        }),
      });

      const data4 = await response.json();

      // --- Handle login failure ---
      if (!data4.success) {
        alert(data4.message || "Invalid Credentials, please try again.");
        outputCred.innerHTML = data4.message || "Invalid Credential, please try again";
        setIsLoading(false);
        RefreshButton();
        return;
      }

      // --- Handle captcha mismatch ---
      if (captchaTexts !== userInput) {
        alert("Incorrect Captcha, please try again.");
        output.innerHTML = "Incorrect Captcha, please try again";
        RefreshButton();
        setIsLoading(false);
        return;
      }

      // --- Successful login ---
      const userData = data4.dataContent[0];
      persistLoginAuth(data4);

      sessionStorage.setItem("currentSchemeName", userData.schemeName);
      sessionStorage.setItem("currentStateName", userData.stateName);
      sessionStorage.setItem("currentDistrictName", userData.districtName);
      // Handle multiple districts - check if userData has multiDistrict field
      if (userData.multiDistrict && userData.multiDistrict.length > 0) {
        sessionStorage.setItem("multiDistrict", JSON.stringify(userData.multiDistrict));
        //console.log("Multi-district data stored:", userData.multiDistrict);
      } else {
        // For scheme 16 users, check if they have multiple districts in districtCode
        if (schemeValue === "16" && userData.districtCode && userData.districtCode.includes(',')) {
          const districtCodes = userData.districtCode.split(',').map(code => code.trim());
          const multiDistrictData = districtCodes.map((code, index) => ({
            districtCode: code,
            districtName: userData.districtName ? userData.districtName.split(',')[index]?.trim() : `District ${code}`,
            stateCode: userData.stateCode,
            stateName: userData.stateName
            
          }));
          sessionStorage.setItem("multiDistrict", JSON.stringify(multiDistrictData));
         // console.log("Multi-district data created from districtCode:", multiDistrictData);
        } else {
          sessionStorage.setItem("multiDistrict", JSON.stringify([]));
          //console.log("No multi-district data found");
        }
      }

      sessionStorage.setItem("userCodeModel", userData.userCode);
      sessionStorage.setItem("userTypeCodeModel", userData.userTypeCode);
      sessionStorage.setItem("stateNameModel", userData.stateCode);
      sessionStorage.setItem("state", userData.state);
      sessionStorage.setItem("districtNameModel", userData.districtCode);
      sessionStorage.setItem("subDistrictNameModel", userData.subDistrictCode);
      sessionStorage.setItem("villageModel", userData.villageCode);
      sessionStorage.setItem("schemeCodeModel", schemeValue);
      sessionStorage.setItem("userNameModel", userData.userName);
      sessionStorage.setItem("stateCodeModel", userData.stateCode);
      sessionStorage.setItem("districtCodeModel", userData.districtCode);
      sessionStorage.setItem("subDistrictCodeModel", userData.subDistrictCode);
      sessionStorage.setItem("user", true);
      navigate(location.state ? "/Map" : "/newadminpanel/dashboard");
      setIsLoading(false);
    } catch (error) {
      console.error("Login Error:", error);
      alert("Something went wrong during login. Please try again.");
      setIsLoading(false);
    }
  };

  asyncPostCallModel();
}

    async function APICallforuserRoleCode(localUserCodeValue) {
        const response = await fetch(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/users/getUsersExt`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                "userCode": localUserCodeValue
              })
        });
        const datausercode = await response.json();
        let localData= datausercode.dataContent[0]
        //console.log("localdata", localData)
        localStorage.removeItem("userRoleCode") 
        localStorage.removeItem("schemeCode")
        localStorage.setItem("userRoleCode", localData.userRoleCode)
        localStorage.setItem("schemeCode", localData.schemeCode)
        sessionStorage.setItem("userRoleName", localData.userRoleName)
        sessionStorage.setItem("departmentName", localData.deptName)
        sessionStorage.setItem("designationName", localData.desigName)
        sessionStorage.setItem("currentSchemeName", localData.schemeName)
        sessionStorage.setItem("currentStateName", localData.stateName)
        sessionStorage.setItem("currentDistrictName", localData.districtName)
        sessionStorage.setItem("multiDistrict", JSON.stringify(localData.multiDistrict));

        
        sessionStorage.setItem("user", true)
        sessionStorage.setItem("InsuranceCode", localData.insuranceCompanyCode) 
        sessionStorage.setItem("userTypeCodeGlobal", localData.userTypeCode) 
        sessionStorage.setItem("orgTypeCodeGlobal", localData.orgTypeCode)  
        sessionStorage.setItem("stateNameGlobal", localData.stateCode)  
        sessionStorage.setItem("districtCodeGlobal", localData.districtCode)  
        sessionStorage.setItem("blockCodeGlobal", localData.blockCode) 
        sessionStorage.setItem("userRoleCode", localData.userRoleCode) 


        location.state  ? navigate("/Map") : navigate("/home/access", {state: { userRoleCodeState : localData.userRoleCode, schemeCodeState : localData.schemeCode}}) 

    }
    function LoginGT() {
      
      // localStorage.setItem("username", String(document.getElementById("yourUsername").value))
      localStorage.setItem("usertype", "admin")
      let outputCred = document.querySelector('#outputCred');
      let output = document.querySelector('#output');

  
      const asyncPostCallGT = async () => {
          try {
           
           
            localStorage.setItem(userName , loginCount)
              const response = await fetch(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/gt/users/getUsersAuth`, {
                  method: 'POST',
                  headers: {
                      'Content-Type': 'application/json'
                  },
                  body: JSON.stringify({
                      "userId": userName,
                      "password": password,
                      "schemeCode": schemeValue
                  })
              });
              const data = await response.json();
              loginDetails = data.dataContent[0];
              //console.log("Login Details !!",loginDetails);
              //console.log("test----",data.dataContent[0].multiDistrict)
              // localStorage.setItem("userRoleCode", loginDetails.userRoleCode)
             if (data.success) {
                  outputCred.innerHTML = ''
                   setIsLoading(false);
              } else {
                alert();
                 localStorage.setItem(userName, ++loginCount)
                  outputCred.innerHTML = "Invalid Credential, please try again";
                   setIsLoading(false);
                  RefreshButton()
              }
              //console.log("captchaText 4" ,captchaText);

              if (captchaTexts === userInput) {
                  output.innerHTML = '';
              } else {
                  RefreshButton()
                  output.innerHTML = "Incorrect Captcha, please try again";
                   setIsLoading(false);
                 
              }
              if(data.success === false) {
                alert(data.message)
                 setIsLoading(false);
              }
              //alert(data.dataContent[0].states[0].stateCode);
              if (data.success && captchaTexts === userInput && data.dataContent[0].isActive === "Yes") {
                localStorage.setItem("userCodeGlobal", data.dataContent[0].userCode)
                localStorage.setItem("username", data.dataContent[0].userName)
                  sessionStorage.setItem("currentSchemeName", data.dataContent[0].schemeName)
                  sessionStorage.setItem("currentStateName", data.dataContent[0].stateName)
                  sessionStorage.setItem("currentDistrictName", data.dataContent[0].districtName)
                  sessionStorage.setItem("multiDistrict", JSON.stringify(data.dataContent[0].multiDistrict));
                  sessionStorage.setItem("userCodeModel", data.dataContent[0].userCode)
                  sessionStorage.setItem("userTypeCodeModel", data.dataContent[0].userTypeCode)
                  sessionStorage.setItem("userRoleCodeModel", data.dataContent[0].userRoleCode)
                  sessionStorage.setItem("stateNameModel", data.dataContent[0].states[0].stateCode)
                  sessionStorage.setItem("stateCodeModel", data.dataContent[0].states[0].stateCode)
                  sessionStorage.setItem("districtNameModel", "")
                  sessionStorage.setItem("subDistrictNameModel", "")
                  sessionStorage.setItem("villageModel","")
                  sessionStorage.setItem("schemeCodeModel", schemeValue)
                  sessionStorage.setItem("departmentNameModel", data.dataContent[0].departmentCode)
                  sessionStorage.setItem("designationNameModel", data.dataContent[0].designationCode)
                  sessionStorage.setItem("companycodeNameModel", data.dataContent[0].companyCode)
                  sessionStorage.setItem("orgTypeCode", data.dataContent[0].orgTypeCode)
                  // sessionStorage.setItem("stateNameModel", data.dataContent[0].states[0].stateCode)
                  // sessionStorage.setItem("districtNameModel", data.dataContent[0].districtCode)
                  // sessionStorage.setItem("subDistrictNameModel", data.dataContent[0].subDistrictCode)
                  // sessionStorage.setItem("villageModel", data.dataContent[0].villageCode)
                  // sessionStorage.setItem("schemeCodeModel", schemeValue)
                 sessionStorage.setItem("userNameModel", data.dataContent[0].userName)
                 sessionStorage.setItem("orgTypeCodeModel", data.dataContent[0].orgTypeCode)
                 sessionStorage.setItem("orgTypeCodeNameModel", data.dataContent[0].companyName)
                  location.state  ? navigate("/Map") : navigate("/newadminpanel/dashboard") 
                   setIsLoading(false);
              }
            
          } catch (error) {
   
              console.log(error)
          }
      }

      asyncPostCallGT()  
      
  }
  function LoginMNT() {
      
    // localStorage.setItem("username", String(document.getElementById("yourUsername").value))
    localStorage.setItem("usertype", "admin")
    let outputCred = document.querySelector('#outputCred');
    let output = document.querySelector('#output');


    const asyncPostCallMNT = async () => {
        try {
         
         
          localStorage.setItem(userName , loginCount)
            const response = await fetch(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/MT/Users/getUsersAuth`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    "userId": userName,
                    "password": password,
                    "schemeCode": schemeValue
                })
            });
            const data = await response.json();
            loginDetails = data.dataContent[0];
            //console.log("Login Details !!",loginDetails);
            
            // Debug: Log all available fields in userData to see mobile number field names
            //console.log("LoginMNT - UserData fields:", Object.keys(loginDetails));
            //console.log("LoginMNT - UserData mobile-related fields:", {
            //    userMobile: loginDetails.userMobile,
            //    mobile: loginDetails.mobile,
            //    mobileno: loginDetails.mobileno,
            //    phone: loginDetails.phone,
            //    phoneNumber: loginDetails.phoneNumber
            //});
            //console.log("LoginMNT - UserData atari-related fields:", {
            //    ataricode: loginDetails.ataricode,
            //    atariCode: loginDetails.atariCode,
            //    atari: loginDetails.atari
            //});
            // localStorage.setItem("userRoleCode", loginDetails.userRoleCode)
           if (data.success) {
                outputCred.innerHTML = ''
            } else {
              
               localStorage.setItem(userName, ++loginCount)
                outputCred.innerHTML = "Invalid Credential, please try again";
                RefreshButton()
                setIsLoading(false);
            }
            console.log("captchaText 4" ,captchaText);

            if (captchaTexts === userInput) {
                output.innerHTML = '';
            } else {
                RefreshButton()
                output.innerHTML = "Incorrect Captcha, please try again";
                setIsLoading(false);
               
            }
            if(data.success === false) {
              alert(data.message)
              setIsLoading(false);
            }
            if (data.success && captchaTexts === userInput && data.dataContent[0].isActive === "Yes") {
                localStorage.setItem("userCodeGlobal", data.dataContent[0].userCode)
                localStorage.setItem("username", data.dataContent[0].userName)
                 sessionStorage.setItem("mobile", data.dataContent[0].mobile)

                sessionStorage.setItem("userCodeModel", data.dataContent[0].userCode)
                sessionStorage.setItem("userTypeCodeModel", data.dataContent[0].userTypeCode)
                sessionStorage.setItem("userRoleCodeModel", data.dataContent[0].userRoleCode)
                sessionStorage.setItem("stateNameModel", data.dataContent[0].stateCode)
                sessionStorage.setItem("fmttiCode", data.dataContent[0].fmttiCode)

                sessionStorage.setItem("fmttiName", data.dataContent[0].fmttiName)

                sessionStorage.setItem("fmtcCode", data.dataContent[0].fmtcCode)

                sessionStorage.setItem("atariCode", data.dataContent[0].atariCode)
                sessionStorage.setItem("kvkCode", data.dataContent[0].kvkCode)
                sessionStorage.setItem("atariName", data.dataContent[0].atariName)
                sessionStorage.setItem("fmttiCode", data.dataContent[0].fmttiCode)
                sessionStorage.setItem("fmttiName", data.dataContent[0].fmttiName)
                sessionStorage.setItem("fmtcCode", data.dataContent[0].fmtcCode)
                sessionStorage.setItem("atariCode", data.dataContent[0].atariCode)
                sessionStorage.setItem("atariName", data.dataContent[0].atariName)
                // Extract district codes and names from all records in the response
                if (data.dataContent && data.dataContent.length > 0) {
                    // Extract unique district codes
                    const districtCodes = [];
                    const districtNames = [];
                    const uniqueDistrictsMap = new Map();

                    // Process all records to extract unique districts
                    data.dataContent.forEach(record => {
                        if (record.districtCode && record.districtCode !== "0" && record.districtCode !== null) {
                            const code = record.districtCode.toString();
                            if (!uniqueDistrictsMap.has(code)) {
                                uniqueDistrictsMap.set(code, record.districtName || "");
                                districtCodes.push(code);
                                districtNames.push(record.districtName || "");
                            }
                        }
                    });

                   // console.log("Extracted district codes:", districtCodes);
                   // console.log("Extracted district names:", districtNames);

                    // Store comma-separated district codes and names
                    if (districtCodes.length > 0) {
                        sessionStorage.setItem("districtCodeModel", districtCodes.join(','));
                        sessionStorage.setItem("districtNameModel", districtNames.join(','));
                      //  console.log("Stored district codes:", districtCodes.join(','));
                       // console.log("Stored district names:", districtNames.join(','));
                    }
                }

                sessionStorage.setItem("subDistrictNameModel", data.dataContent[0].subDistrictCode)
                sessionStorage.setItem("villageModel", data.dataContent[0].villageCode)
                sessionStorage.setItem("schemeCodeModel", schemeValue)
                sessionStorage.setItem("departmentNameModel", data.dataContent[0].departmentCode)
                sessionStorage.setItem("designationNameModel", data.dataContent[0].designationCode)
                sessionStorage.setItem("companycodeNameModel", data.dataContent[0].companyCode)
                sessionStorage.setItem("userNameModel", data.dataContent[0].userName)
                sessionStorage.setItem("orgTypeCodeModel", data.dataContent[0].orgTypeCode)
                sessionStorage.setItem("orgTypeCodeNameModel", data.dataContent[0].companyName)

                // Store complete login data array for reference
                //console.log("LoginMNT - Storing complete login data array:", data.dataContent);
                sessionStorage.setItem("loginData", JSON.stringify(data.dataContent));

                // Set user session for ProtectedRoute
                sessionStorage.setItem("user", true);

                setIsLoading(false);
                location.state ? navigate("/Map") : navigate("/MNT/dashboardMnT")
            }
            
            //if (data.success && captchaTexts === userInput && data.dataContent[0].isActive === "Yes") {
            //  localStorage.setItem("userCodeGlobal", data.dataContent[0].userCode)
            //  localStorage.setItem("username", data.dataContent[0].userName)
            
            //    sessionStorage.setItem("userCodeModel", data.dataContent[0].userCode)
            //    sessionStorage.setItem("userTypeCodeModel", data.dataContent[0].userTypeCode)
            //    sessionStorage.setItem("userRoleCodeModel", data.dataContent[0].userRoleCode)
            //    sessionStorage.setItem("stateNameModel",data.dataContent[0].stateCode)
            //    sessionStorage.setItem("districtNameModel", data.dataContent[0].districtCode)
            //    sessionStorage.setItem("subDistrictNameModel", data.dataContent[0].subDistrictCode)
            //    sessionStorage.setItem("villageModel", data.dataContent[0].villageCode)
            //    sessionStorage.setItem("schemeCodeModel", schemeValue)
            //    sessionStorage.setItem("departmentNameModel", data.dataContent[0].departmentCode)
            //    sessionStorage.setItem("designationNameModel", data.dataContent[0].designationCode)
            //    sessionStorage.setItem("companycodeNameModel", data.dataContent[0].companyCode)
            //    sessionStorage.setItem("userNameModel", data.dataContent[0].userName)
            //    sessionStorage.setItem("orgTypeCodeModel", data.dataContent[0].orgTypeCode)
            //    sessionStorage.setItem("orgTypeCodeNameModel", data.dataContent[0].companyName)
            //    sessionStorage.setItem("UserId", data.dataContent[0].UserId)
                
            //    // Store atariCode if available
            //    sessionStorage.setItem("ataricode", data.dataContent[0].ataricode || data.dataContent[0].atariCode || "");
                
            //    // Store mobile number for password change API - try multiple possible field names
            //    const mobileValue = data.dataContent[0].userMobile || data.dataContent[0].mobile || data.dataContent[0].mobileno || "";
            //    sessionStorage.setItem("userMobile", mobileValue);
            //    sessionStorage.setItem("mobileNo", mobileValue);
            //    sessionStorage.setItem("mobile", mobileValue);
            //    sessionStorage.setItem("mobileno", mobileValue);
                
            //    // Store FMTTI data if available
            //    if (data.dataContent[0].fmttiCode) {
            //        console.log("LoginMNT - Setting FMTTI code:", data.dataContent[0].fmttiCode);
            //        sessionStorage.setItem("fmttiCode", data.dataContent[0].fmttiCode);
            //    }
            //    if (data.dataContent[0].fmttiName) {
            //        console.log("LoginMNT - Setting FMTTI name:", data.dataContent[0].fmttiName);
            //        sessionStorage.setItem("fmttiName", data.dataContent[0].fmttiName);
            //    }
                
            //    // Store FMTC data if available (this was missing!)
            //    if (data.dataContent[0].fmtcCode) {
            //        console.log("LoginMNT - Setting FMTC code:", data.dataContent[0].fmtcCode);
            //        sessionStorage.setItem("fmtcCode", data.dataContent[0].fmtcCode.toString());
            //    }
            //    if (data.dataContent[0].fmtcName) {
            //        console.log("LoginMNT - Setting FMTC name:", data.dataContent[0].fmtcName);
            //        sessionStorage.setItem("fmtcName", data.dataContent[0].fmtcName);
            //    }
                
            //    // Store complete login data for reference (this was also missing!)
            //    const loginDataToStore = {
            //        ...data.dataContent[0],
            //        fmttiCode: data.dataContent[0].fmttiCode?.toString(),
            //        fmtcCode: data.dataContent[0].fmtcCode?.toString(),
            //        fmttiName: data.dataContent[0].fmttiName,
            //        fmtcName: data.dataContent[0].fmtcName
            //    };
            //    console.log("LoginMNT - Storing login data:", loginDataToStore);
            //    sessionStorage.setItem("loginData", JSON.stringify(loginDataToStore));
                
            //    // Set user session for ProtectedRoute
            //    sessionStorage.setItem("user", true);
                
            //    setIsLoading(false);
            //    location.state ? navigate("/Map") : navigate("/MNT/dashboardMnT") 
            //}
          
        } catch (error) {
            console.log(error)
            setIsLoading(false);
        }
    }

    asyncPostCallMNT()  
    
}
  
    function handleLogin(event) {
      setPassword(event.target.value)
        document.getElementById("output").innerHTML = '';
        document.getElementById("outputCred").innerHTML = '';
        
            if (event.keyCode === 13) {
             
                LoginCropic();
            }
    }

    function handleLogin2(event) {
      document.getElementById("output2").innerHTML = '';
      document.getElementById("outputCred2").innerHTML = '';
          if (event.keyCode === 13) {
              LoginCropic();
          }
  }

  function handleLoginInspection(event) {
    document.getElementById("output3").innerHTML = '';
    document.getElementById("outputCred3").innerHTML = '';
        if (event.keyCode === 13) {
            LoginInspection();
        }

      }

      function handleLoginModel(event) {
        document.getElementById("output4").innerHTML = '';
        document.getElementById("outputCred4").innerHTML = '';
            if (event.keyCode === 13) {
                LoginModel();
            }
    
          }
    

    function validateMobileNumber() {
      var regmm='^([6-9]{1})([0-9]{9})$';
    var regmob = new RegExp(regmm);
    if(regmob.test(String(document.getElementById("MobileNumber").value))){
      generateOTP()
    } else {
        alert("Enter Correct Mobile Number")
        return;
    }    
    }

    function handleMobileNumber(value) {
      const valueFinal = value.replace(/\D/g, "");
      document.getElementById("MobileNumber").value = valueFinal;
    }


  function generateOTP() {

    var myHeaders = new Headers();
myHeaders.append("Content-Type", "application/json");

var raw = JSON.stringify({
  "mobileno": String(document.getElementById("MobileNumber").value) 
});

var requestOptions = {
  method: 'POST',
  headers: myHeaders,
  body: raw,
  redirect: 'follow'
};

fetch(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/otpauth`, requestOptions)
  .then(response => response.json())
  .then(result => {
    if(result.success === true) {
      handleTimer()
      document.getElementById("send_otp_btn").innerText = "Resend OTP"
    }
   setIsLoading(false);
    alert(result.message)
  })
  .catch(error => console.log('error', error));
  }

  function handleTimer() {

    var element = document.getElementById('send_otp_btn');
    element.disabled = true;
    

     var timeLeft = 60;
    var elem = document.getElementById('timer_text');
    
    var timerId = setInterval(countdown, 1000);
    
    function countdown() {
      if (timeLeft == -1) {
        clearTimeout(timerId);
        element.disabled = false;
        elem.innerHTML = ""
      } else {
        elem.innerHTML = "00 : "+timeLeft;
        timeLeft--;
      }
    }

  }

    function LoginApp() {
       
   
      let schemeCode = schemeValue;
      //const isSchemeBlocked = BLOCKED_SCHEMES.includes(schemeGlobal);
      //console.log('schemeCode: ', schemeCode);
    if(schemeCode === ''){
      alert('Please Select Scheme');
      setIsLoading(false);
      return false;
    }
     setIsLoading(true); 
      //console.log('schemeCode: ', schemeCode);
      // if(schemeCode === "1") 
      console.log('schemeCode: ', schemeCode);
      console.log('BLOCKED_SCHEMES: ', BLOCKED_SCHEMES);
      if (BLOCKED_SCHEMES.includes(schemeCode)) 
      {
        //console.log('called in 1');
        // LoginCropic() changed at 14 Nov 2025
        LoginMIDH();
    }
    else if(schemeCode === "02") 
    {
      LoginInspection()
    }
    else if(schemeCode === "12") 
    {
      LoginGT()
    }
    else if(schemeCode === "13") 
    {
        LoginGT()
    }
    else if(schemeCode === "16") 
      {
          LoginMNT()
      }
    //else if (schemeCode === "8") {
    //    console.log('called in 8');
    //      LoginMIDH()
    //  }
    else 
    {
        //console.log('called in default 11111111');
      LoginModel()
    }
  }

  const handleToggle = () => {
    // if (type==='password'){
    //    setIcon(faEye);
    //    setType('text')
    // } else {
    //    setIcon(faEyeSlash)
    //    setType('password')
    // }
    setPasswordShown(passwordShown ? false : true);
 }

  const handleOtpVisibilityToggle = () => {
    const otpInput = document.getElementById("inputotp");
    const showEye = document.getElementById("show_eye");
    const hideEye = document.getElementById("hide_eye");
    if (!otpInput) return;

    if (otpInput.type === "password") {
      otpInput.type = "text";
      hideEye?.classList.remove("d-none");
      showEye?.classList.add("d-none");
    } else {
      otpInput.type = "password";
      hideEye?.classList.add("d-none");
      showEye?.classList.remove("d-none");
    }
  };

    return (
      <>

<main className="main_back">
        <div className="container">
          <section className="section register min-vh-100 d-flex flex-column align-items-center justify-content-center">
            <div className="container">
             <div className="backhome">
              <Link to="/" className="btn btn-success w-100 ">Back To Home</Link>
             </div> 
              <div className="row justify-content-center">
                <div className="col-xs-12 col-sm-12 col-md-8 col-lg-4 card">
                  <div className="row">
                    {/* <div className="col-lg-6 padding_zero leftLoginimgs">
                      <div className="d-flex justify-content-center">
                      <div className="d-flex justify-content-center">
                        <Link to="/" className="backToHome">Back To Home</Link>
                      </div>
                      </div>
                    </div> */}

                    <div className="col-lg-12 login_box">
                      <div className="card-body">
                        <div className="row">
                         
                            <div className="col-md-12">
                            <div className="row">
                          <div className="col-md-2"><img src={agricultureDarkLogo} alt="agriculture government of india" className="agriculture-logo" /></div>
                          <div className="col-md-10 px-0">   <Link to="/" ><img src={KrishiMapperlogo} alt="Krishi Mapper Logo" className="loginKLogo" /></Link> 
                          <h5 className="text-center pb-0 fs-4">
                          Login to Your Account
                        </h5>
                          </div>
                          </div>
                          </div>



                    

                        </div>
                     

                       
                        {/* <h6 className="text-center small">
                          Enter your User Id and Password to login
                        </h6> */}

                        <div className="row justify-content-center">
                          <Tabs
                            justify
                            variant="pills"
                            defaultActiveKey="tab-1"
                            className="mb-1 p-0"
                          >
                            <Tab eventKey="tab-1" title="Login With Password">
                              <div className="col-12">
                                <div className="input-group">
                                  <label>User Id</label>
                                  <div className="input-group has-validation">
                                    <span className="input-group-text">
                                      <i>
                                        <FontAwesomeIcon icon={faUserAlt} />
                                      </i>{" "}
                                    </span>
                                    <input
                                      type="text"
                                      min="10"
                                      max="12"
                                      placeholder="Username"
                                      name="username"
                                      className="form-control"
                                      id="yourUsername"
                                      onKeyUp={(e) => setUserName(e.target.value)}
                                      required
                                    />
                                    <div className="invalid-feedback">
                                      Please enter your Mobile no.
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="col-12">
                                <label> Password </label>
                                <div className="input-group has-validation">
                                  <span className="input-group-text">
                                    <i>
                                <FontAwesomeIcon icon={faKey} />
                                    </i>{" "}
                                  </span>
                                  <input
                                   type={passwordShown ? "text" : "password"}
                                    name="password"
                                    className="form-control"
                                    placeholder="Password"
                                    id="yourPassword"
                                    onKeyUp={(e) => handleLogin(e)}
                                    required                           
                                  />
                                <i className="flex justify-around items-center showhidebtns"  onClick={handleToggle}>
                                      <FontAwesomeIcon icon={passwordShown ? faEyeSlash : faEye} />
                                    </i>{" "}
                                </div>
                                <span
                                  id="outputCred"
                                  className="redText"
                                ></span>
                                <div className="invalid-feedback">
                                  {" "}
                                  Please enter your OTP!
                                </div>
                              </div>

                              <div className="col-12">
                    <label >
                      Scheme
                    </label>
                    <select
                      id="Scheme"
                      required
                      className="form-select"
                      onChange={(e) => setSchemeValue(e.target.value)}
                      value={schemeValue}
                    >
                      <option defaultValue>Choose...</option>
                      <option value="3">Agroforestry</option> 
                      <option value="20">Agricultural Technology Management Agency(ATMA)</option> 
                      <option value="46">CIH</option>                
                      <option value="10">Coconut Development Board (CDB)</option>  
                      <option value="01">Cropic</option> 
                      <option value="13">Crop Condition</option>
                      <option value="11">Directorate of Arecanut and Spices Development (DASD)</option> 
                      <option value="17">Directorate of Cashew and Cocoa Development (DCCD)</option>  
                      <option value="44">Fostering seeds</option>
                      <option value="12">Ground Truthing</option>
                      <option value="02">Inspection</option> 
                      <option value="8">Mission for Integrated Development of Horticulture (MIDH)</option> 
                      <option value="9">Mission Organic Value Chain Development (MOVCD)</option>
                      <option value="16">M&T</option>
                      <option value="6">Natural Farming(NF)</option>   
                      <option value="21">National Bamboo Mission (NBM)</option>
                      <option value="7">National Beekeeping and Honey Mission (NBHM)</option>    
                      <option value="5">National Mission on Edible Oils-  Oil Seeds (NMEO-OS)/Seed Distribution</option>  
                      <option value="14">National mission on Edible Oils-OilPalm (NMEO-OP)</option>
                      <option value="1">Per Drop More Crop(PDMC) - Micro Irrigation</option> 
                      <option value="48">Pulse Mission</option>
                      <option value="22">Paramparagat Krishi Vikas Yojana (PKVY)</option>
                      <option value="2">Rainfed Area Development (RAD)</option>
                      <option value="15">RKVY DPR</option>
                      
                      
                    </select>
                  </div>

                              <div className="col-12">
                                <label>Enter Captcha</label>
                                <div id="captchaBackground">
                                  <strong>
                                    <span id="captcha"></span>
                                  </strong>
                                  <strong>
                                    <input
                                      id="textBox"
                                      type="text"
                                      name="text"
                                      placeholder="Captcha"
                                      required
                                      onKeyUp={(e) => setUserInput(e.target.value)}
                                    />
                                  </strong>
                                  <strong>
                                    <FontAwesomeIcon
                                      id="refresh"
                                      icon={faRefresh}
                                      onClick={RefreshButton}
                                    ></FontAwesomeIcon>
                                  </strong>
                                </div>
                                <span id="output" className="redText"></span>
                              </div>

                              <div className="col-12">

                                 <button
                                  className="btn btn-success w-100"
                                  onClick={LoginApp}
                                  id="login_btn"
                                  disabled={isLoading} // Disable button when loading
                                >
                                  {isLoading ? <i className="spinner-border spinner-border-sm">  </i> :   <i className="bi bi-globe-americas"></i>}       
                                  {isLoading ? " Logging in..." : "Login"}
                                </button>
                               
                               
                              </div>
                            </Tab>
                            <Tab eventKey="tab-2" title="Login With OTP">
                              <div className="row">
                                <div className="col-md-12">
                                  <div className="input-group">
                                    <label>Mobile Number</label>
                                    <div className="input-group has-validation">
                                      <span className="input-group-text">
                                        <i>
                                          <FontAwesomeIcon icon={faMobileAlt} />
                                        </i>{" "}
                                      </span>
                                      <input
                                        type="text"
                                        maxLength={10}
                                        onChange={(e) => handleMobileNumber(e.target.value)}
                                        placeholder="Mobile Number"
                                        name="MobileNumber"
                                        className="form-control"
                                        id="MobileNumber"
                                        required
                                      />
                                      <div className="invalid-feedback">
                                        Please enter your Mobile no.
                                      </div>
                                    </div>
                                  </div>
                                  <button className="btn btn-success btn-sm pull-right" id="send_otp_btn" onClick={validateMobileNumber}>
                                    Send OTP
                                  </button>
                                  <span id="timer_text"></span>
                                </div>
                              </div>

                              <div className="row">
                                <div className="col-md-12">
                                  <label>Enter OTP </label>
                                  <div className="input-group has-validation">
                                    <span className="input-group-text">
                                      <i>
                                        <FontAwesomeIcon icon={faKey} />
                                      </i>{" "}
                                    </span>
                                    <input
                                      type="password"
                                      name="password"
                                      className="form-control"
                                      placeholder="Enter OTP"
                                      id="inputotp"
                                      onKeyUp={(e) => handleLogin(e)}
                                      required
                                     
                                    />
                                    <div className="input-group-append">
                                      <span
                                        onClick={handleOtpVisibilityToggle}
                                        role="button"
                                        tabIndex={0}
                                        onKeyDown={(e) => {
                                          if (e.key === "Enter" || e.key === " ") {
                                            e.preventDefault();
                                            handleOtpVisibilityToggle();
                                          }
                                        }}
                                      >
                                        <i
                                          className="fas fa-eye"
                                          id="show_eye"
                                        ></i>
                                        <i
                                          className="fas fa-eye-slash d-none"
                                          id="hide_eye"
                                        ></i>
                                      </span>
                                    </div>
                                  </div>
                                  <span
                                    id="outputCred2"
                                    className="redText"
                                  ></span>
                                  <div className="invalid-feedback">
                                    {" "}
                                    Please enter your OTP!
                                  </div>
                                </div>
                              </div>

                              <div className="col-12">
                              <label>Enter Captcha</label>
                                <div id="captchaBackground2">
                                  <strong>
                                    <span id="captcha2"></span>
                                  </strong>
                                  <strong>
                                    <input
                                      id="textBox2"
                                      type="text"
                                      name="text"
                                      placeholder="Captcha"
                                      required
                                      onKeyUp={(e) => setUserInput2(e.target.value)}
                                    />
                                  </strong>
                                  <strong>
                                    <FontAwesomeIcon
                                      id="refresh2"
                                      icon={faRefresh}
                                      onClick={RefreshButton2}
                                    ></FontAwesomeIcon>
                                  </strong>
                                </div>
                                <span id="output2" className="redText"></span>
                              </div>

                              <div className="col-12">
                                <button
                                  className="btn btn-success w-100"
                                  onClick={LoginCropic2}
                                  id="login_btn"
                                >
                                  Login
                                </button>
                              </div>
                            </Tab>
                            
                           
                          </Tabs>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
        {/* <footer className="login footer">
          <div className="credits">
            Website Content Owned & Managed by Department of Agriculture &
            Farmers Welfare | MoA&FW | Government of India, India
            <br />
            <a href="#">
              Designed and Developed by: DAD/IT, Ministry of Agriculture, New
              Delhi, India.
            </a>
          </div>
        </footer> */}
      </main>
      </>
    );
}

export {
    Login,
    loginDetails,
}